import {Container, Card, Row, Col, Button } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import {useRef, useEffect} from 'react'
import logo from './logo.svg';
import './App.css';
import bg1 from './img/bg1.jpg'
import {BsJournalRichtext, BsBook, BsStack, BsVectorPen,BsGem,BsLinkedin,BsFillTerminalFill} from 'react-icons/bs';
import {AiOutlineMail, AiOutlineLogin, AiOutlineLogout, AiOutlineCaretUp, AiOutlineCopy} from 'react-icons/ai';

//<a href="readme.html#ann_link"> ANN </a>
function App() {
  const fref = useRef(null)
   
   useEffect(()=>{
    const iframe = fref.current
    if (!iframe) return
    
    iframe.onload = function() {
      // Keep iframe width responsive and only adjust height based on content
      iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px'
    }
  })
  return (
    <>
      <Container fluid>
        <Row>
          <Col xs={2} style={{ backgroundImage: `url(${bg1})` }}>
            <div> </div>
          </Col>
          <Col xs={9}>
            <div style={{ marginLeft: '16px', marginTop: '10px' }}>
              <BsBook />
              <a href='https://irfanhasib0.github.io/blogs' target='_blank'>Blog</a>
              &nbsp;&nbsp;
              <BsBook />
              <a href='/research.html' target='_blank'>Research</a>
            </div>
            <iframe
              ref={fref}
              src={'readme_v4.html'}
              scrolling='yes'
              width='100%'
              height='1000'
              style={{ maxWidth: '100%' }}
              title='Main Content'
            ></iframe>
          </Col>
        </Row>
      </Container>
      </>
  );
}

export default App;
